export type UserState = {
  loginEmail: string
  isDisplayTosCheckbox: boolean
}

const state = {
  loginEmail: '',
  isDisplayTosCheckbox: true
} as UserState

export default state
